/* Responsive picture with WebP + JPG fallback. */
export const Img = ({
  name,
  alt,
  className = "",
  imgClassName = "",
  loading = "lazy",
  position = "center",
  fit = "cover",
  ...rest
}) => (
  <picture className={className}>
    <source srcSet={`/images/${name}.webp`} type="image/webp" />
    <img
      src={`/images/${name}.jpg`}
      alt={alt}
      loading={loading}
      decoding="async"
      className={`img-warm ${imgClassName}`}
      style={{ objectFit: fit, objectPosition: position }}
      {...rest}
    />
  </picture>
);
